export default __webpack_public_path__ + "static/media/endodontie.7375635d.png";